import React from "react";

var PenIcon = function PenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M22.671 1.329A4.503 4.503 0 0 0 19.464 0a4.504 4.504 0 0 0-3.207 1.329L16 1.586l-.172-.172a4.003 4.003 0 0 0-5.656 0L6.293 5.293a.999.999 0 1 0 1.414 1.414l3.879-3.879a2.003 2.003 0 0 1 2.828 0l.172.172L10 7.586 16.414 14l6.257-6.257A4.506 4.506 0 0 0 24 4.536a4.503 4.503 0 0 0-1.329-3.207zM4.073 13.513l-1.964 6.964-1.815 1.815a.999.999 0 1 0 1.413 1.415l1.815-1.815 6.964-1.964L15 15.414 8.586 9z"
  }));
};

PenIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
PenIcon.defaultProps.solid = true;
export default PenIcon;